import * as $ from 'jquery';

export function initTooltips() {
  $('[data-toggle="tooltip"]').tooltip();
}
